export default __webpack_public_path__ + "static/media/toggleIcon.8d4bf2b8.svg";